import React from "react";
import ContactUsForm from "../components/forms/ContactUsForm";
import { Box, Grid, Typography } from "@mui/material";
import BreadcrumbsTemplate from "../components/misc/BreadcrumbsTemplate";
import MoreCallOptions from "../components/ContactUs/MoreCallOptions";
import { colors, eyebrowSx, fonts, radii, shadows } from "../theme/designTokens";

export default function ContactUsScreen() {
  return (
    <Box sx={{ bgcolor: colors.paper }}>
      <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3 } }}>
        <Box sx={{ pt: 2.5 }}>
          <BreadcrumbsTemplate b3="Contact Us" sx={{ mx: 0 }} />
        </Box>

        <Box sx={{ textAlign: "center", maxWidth: 640, mx: "auto", pt: 3, pb: 5 }}>
          <Box sx={eyebrowSx}>Get in Touch</Box>
          <Typography
            sx={{
              fontFamily: fonts.display,
              fontWeight: 800,
              fontSize: { xs: "1.8rem", sm: "2.2rem" },
              color: colors.ink,
              mt: 2,
            }}
          >
            Feel Free to Talk to Us
          </Typography>
          <Typography sx={{ fontSize: 15, color: colors.ink2, lineHeight: 1.65, mt: 1.5 }}>
            Our pharmacist-backed support team is ready to help with orders,
            prescriptions, or general questions.
          </Typography>
        </Box>

        <Grid container spacing={3} sx={{ pb: 6 }}>
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                borderRadius: radii.lg,
                boxShadow: shadows.card,
                border: `1px solid ${colors.line}`,
                bgcolor: colors.white,
                p: { xs: 2.5, sm: 4 },
              }}
            >
              <ContactUsForm />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                borderRadius: radii.lg,
                boxShadow: shadows.card,
                border: `1px solid ${colors.line}`,
                bgcolor: colors.white,
                p: { xs: 2.5, sm: 3 },
              }}
            >
              <Typography sx={{ fontFamily: fonts.display, fontWeight: 700, fontSize: 15, color: colors.ink, mb: 2 }}>
                More Ways to Reach Us
              </Typography>
              <MoreCallOptions contactMedium="Message" />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
